import React from 'react'
import Slider from 'react-slick'
import Clint_1 from '../../../assets/images/home_page_3/adv-slider/01.png'

const clintSlide = {
    slidesToShow: 4,
    Infinity: true,
    autoplay: true,
    autoplaySpeed: 3000,
    Speed: 2000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const Clint = () => {
    return (
        <>
            <div id="client-slider" className="client-slider-main-block-three">
                <Slider className="slider client-slider-center-mode" {...clintSlide}>
                    <div className="client-slider-img">
                        <img
                            src={Clint_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Clint_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Clint_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Clint_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Clint_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                    <div className="client-slider-img">
                        <img
                            src={Clint_1}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                </Slider>
            </div>

        </>
    )
}

export default Clint
